import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let TimerangepickerComp;

class Timerangepicker extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: TimerangepickerComp };
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/timerangepicker-comp" */
            "../../../components/javascript/zcat-components/timerangepicker-comp"
        ).then(function(res) {
            TimerangepickerComp = res.TimerangepickerComp;
        }));

        
;
    }
}

export {Timerangepicker};

